import CommunicationActivity from "../views/schooladmin/CommunicationActivity";

export default [
	{
		path: "/schooladmin/communication_activity",
		meta: { requiresPortalAdmin: true },
		components: {
			content: CommunicationActivity
		}
	}
];
